/** @format */

import $ from "jquery";
import axios from "axios";
import { Input } from "antd";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import React, { useEffect, useState, useRef } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { SearchOutlined, ArrowLeftOutlined } from "@ant-design/icons";

import pdf from "../../../../icons/pdf.png";
import print from "../../../../icons/print.png";
import excel from "../../../../icons/excel.png";
import { header } from "../../../../components/api/Header";
import { ExcelPrint, Pdf } from "../../../../components/functions/Print";
import { getEnv } from "../../../../lib/env";

function ByDistrict({ date, setRegionName, regionName }) {
  const params = useParams();
  const conponentPDF = useRef();
  const navigate = useNavigate();
  const state = useSelector((state) => state);

  const regions = state.data.regions;
  const [data, setData] = useState([]);
  const [manbalar, setManbalar] = useState([]);
  const [loading, setLoading] = useState(false);
  const [regionId, setRegionId] = useState(params.regionId);

  const setSearch = (text) => {
    $("tbody tr").each(function () {
      if ($(this)[0].className.toUpperCase().indexOf(text.toUpperCase()) > -1) {
        $(this)[0].style.display = "";
      } else {
        $(this)[0].style.display = "none";
      }
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/suvdanfoydalanish/bydistricts?regionId=" +
            regionId +
            "&date=" +
            date,
          header()
        );
        setData(res.data["data"]);
        setManbalar(res.data["manbalar"]);
      } catch (e) {
        console.log("Xato", e);
        alert("Serverga ulanishda xato!");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [date, regionId]);

  let sums =
    manbalar && manbalar.length > 0 ? Array(manbalar.length + 2).fill(0) : [0];

  let sums1 =
    manbalar && manbalar.length > 0 ? Array(manbalar.length + 2).fill(0) : [0];

  let sums2 =
    manbalar && manbalar.length > 0 ? Array(manbalar.length + 2).fill(0) : [0];

  const changeRegionHandler = (id) => {
    setRegionId(id);
    navigate("/suvdanfoydalanish/" + id);
  };

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  return (
    <div className='table-box-con'>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <div className='d-flex'>
            <NavLink to='/suvdanfoydalanish' className='btn btn-sm btn-primary'>
              <ArrowLeftOutlined />
            </NavLink>
            &nbsp;&nbsp;&nbsp;
            <Input
              prefix={<SearchOutlined className='site-form-item-icon' />}
              placeholder='Search'
              onChange={(e) => setSearch(e.target.value)}
            />
            &nbsp;&nbsp;&nbsp;
            <select
              className='form-select form-control-sm'
              value={regionId}
              onChange={(e) => changeRegionHandler(e.target.value)}>
              {regions
                ? regions.map((r, i) => {
                    return (
                      <option key={i} value={r.id}>
                        {r.name}
                      </option>
                    );
                  })
                : null}
            </select>
          </div>
        </div>

        <ul className='table-top-right'>
          <li>
            <button className='btn p-0' onClick={() => generatePDF()}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <button onClick={() => Pdf("tblData")} className='btn p-0'>
              <img src={pdf} alt='404' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() =>
                ExcelPrint("Suvdan foydalanish " + regionName, date, "tblData")
              }>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      <div className='table-responsive tableFixHead' id='tableFlexible'>
        <div ref={conponentPDF} style={{ width: "100%" }}>
          <table className='table table-bordered table-style' id='tblData'>
            <thead>
              <tr>
                <th
                  rowSpan={2}
                  scope='col'
                  className='sticky st1'
                  style={{
                    width: "33px",
                    maxWidth: "33px",
                    minWidth: "33px",
                  }}>
                  №
                </th>

                <th
                  rowSpan={2}
                  scope='col'
                  className='sticky'
                  style={{
                    left: "33px",
                    width: "220px",
                    maxWidth: "220px",
                    minWidth: "220px",
                  }}>
                  Tumanlar
                </th>

                <th colSpan={2} scope='col'>
                  Olinayotgan suv m<sup>3</sup>/sek
                </th>

                {/* <th rowSpan={1} scope='col'>
                  %
                </th> */}

                <th colSpan={manbalar.length} scope='col'>
                  Shu jumladan manbalar bo’yicha
                </th>
              </tr>

              <tr>
                <th
                  style={{
                    width: "90px",
                    maxWidth: "90px",
                    minWidth: "90px",
                  }}
                  rowSpan={2}
                  scope='col'>
                  Limit
                </th>

                <th
                  style={{
                    width: "90px",
                    maxWidth: "90px",
                    minWidth: "90px",
                  }}
                  rowSpan={2}
                  scope='col'>
                  Xaqiqat
                </th>

                {manbalar
                  ? manbalar.map((m, i) => {
                      return (
                        <th key={i} colSpan={1} scope='col'>
                          {m.manba_nomi}
                        </th>
                      );
                    })
                  : null}
              </tr>

              {/* <tr>
                {manbalar.length > 0
                  ? Array(manbalar.length * 2)
                      .fill(0)
                      .map((p, i) => {
                        if (i % 2 == 0) {
                          return (
                            <th scope='col' key={i}>
                              Limit
                            </th>
                          );
                        } else {
                          return (
                            <th scope='col' key={i}>
                              Xaqiqat
                            </th>
                          );
                        }
                      })
                  : null}
              </tr> */}
            </thead>

            {data.length > 0
              ? data.map((d, index) => {
                  if (index == 0) {
                    sums =
                      manbalar && manbalar.length > 0
                        ? Array(manbalar.length + 2).fill(0)
                        : [0];
                    sums1 =
                      manbalar && manbalar.length > 0
                        ? Array(manbalar.length + 2).fill(0)
                        : [0];
                    sums2 =
                      manbalar && manbalar.length > 0
                        ? Array(manbalar.length + 2).fill(0)
                        : [0];
                    // sums2[0] = add(sums2[0], d.limiti);
                    sums2[1] = add(sums2[1], d.xaqiqatda);
                    // sums2[2] = protsent(sums2[0], sums2[1]);
                  }

                  if (index > 0 && d.id < 998) {
                    // sums[0] = add(sums[0], d.limiti);
                    sums[1] = add(sums[1], d.xaqiqatda);
                    // sums[2] = protsent(sums[0], sums[1]);
                  }

                  if (index > 0) {
                    // sums1[0] = add(sums1[0], d.limiti);
                    sums1[1] = add(sums1[1], d.xaqiqatda);
                    // sums1[2] = protsent(sums1[0], sums1[1]);
                  }

                  return (
                    <tbody key={index}>
                      {index == 1 ? (
                        <tr>
                          <td colSpan={manbalar.length + 2}>
                            <b>Shu Jumladan Tumanlar Chegarasida</b>
                          </td>
                        </tr>
                      ) : null}

                      {d.id == 998 ? (
                        <tr>
                          <td className='sticky st1'></td>

                          <td className='sticky' style={{ left: "33px" }}>
                            Jami
                          </td>

                          {sums.map((s, ind) => {
                            return <td key={ind}>{s}</td>;
                          })}
                        </tr>
                      ) : null}

                      <tr className={d.name}>
                        <td className='sticky st1'>{d.ind}</td>

                        <td className='sticky' style={{ left: "33px" }}>
                          {d.name}
                        </td>

                        {/* <td>{d.limiti}</td> */}

                        <td>{d.xaqiqatda}</td>

                        {/* <td>{protsent(d.limiti, d.xaqiqatda)}</td> */}

                        {d.data
                          ? Object.values(d.data).map((lx, i) => {
                              if (index > 0 && d.id < 998) {
                                sums[i + 3] = add(sums[i + 3], lx);
                              }

                              if (index > 0) {
                                sums1[i + 3] = add(sums1[i + 3], lx);
                              }

                              if (index == 0) {
                                sums2[i + 3] = add(sums2[i + 3], lx);
                              }

                              return <td key={i}>{lx}</td>;
                            })
                          : Array(manbalar.length + 1)
                              .fill(0)
                              .map((_, i) => {
                                return (
                                  <th
                                    style={{
                                      width: "110px",
                                      maxWidth: "110px",
                                      minWidth: "110px",
                                    }}
                                    scope='col'
                                    key={i}></th>
                                );
                              })}
                      </tr>
                    </tbody>
                  );
                })
              : null}

            {/* <tbody>
              <tr>
                <td className='sticky st1'></td>

                <td className='sticky' style={{ left: "33px" }}>
                  Jami
                </td>

                {sums1.map((s, i) => {
                  return <td key={i}>{s}</td>;
                })}
              </tr>

              <tr>
                <td className='sticky st1'></td>

                <td className='sticky' style={{ left: "33px" }}>
                  Yo'qolishga
                </td>

                {sums2.map((s, i) => {
                  if (i == 2) {
                    return (
                      <td key={i}>
                        {protsent(
                          farq(sums2[0], sums1[0]),
                          farq(sums2[1], sums1[1])
                        )}
                      </td>
                    );
                  }
                  return <td key={i}>{farq(s, sums1[i])}</td>;
                })}
              </tr>

              <tr>
                <td className='sticky st1'></td>

                <td className='sticky' style={{ left: "33px" }}>
                  FIK
                </td>

                {sums1.map((s, i) => {
                  if (i == 2) {
                    return <td key={i}>{protsent(s,sums2[i])}</td>;
                  }
                  return <td key={i}>{protsent(s, sums2[i])}</td>;
                })}
              </tr>
            </tbody> */}
          </table>
        </div>
      </div>
    </div>
  );
}

export default ByDistrict;

const add = (a, b) => {
  if (!a || typeof a == "undefined") {
    a = 0;
  }
  if (!b || typeof b == "undefined") {
    b = 0;
  }

  let s = parseFloat(a) + parseFloat(b);
  if (s % 1 == 0) return s;
  return s.toFixed(2);
};

// const protsent = (a, b) => {
//   if (!a || typeof a == "undefined" || a == "-") {
//     return "-";
//   }
//   if (!b || typeof b == "undefined" || b == "-") {
//     return "-";
//   }
//   let s = (parseFloat(b) * 100) / parseFloat(a);
//   if (s % 1 == 0) return s;
//   return s.toFixed(2);
// };

// const farq = (a, b) => {
//   if (!a || typeof a == "undefined" || a == "-") {
//     a = 0;
//   }
//   if (!b || typeof b == "undefined" || b == "-") {
//     b = 0;
//   }
//   let s = parseFloat(a) - parseFloat(b);
//   if (s % 1 == 0) return s;
//   return s.toFixed(2);
// };
